import { ApiClient, ApiErrorMessage } from './ApiClient';
export interface TransitsCustomType {
  datas: { spotId: string; trains: TrainsType[] }[];
  obc_error: ObcErrorType[];
}

interface TransitsType {
  datas: Datas;
  obc_error: ObcErrorType[];
}

interface Datas {
  [key: string]: TrainsType[];
}

export interface ObcErrorType {
  formated_obc_error_time: string;
  staff_name: string;
  station_name: string;
  train_no: number;
  updated_at: object;
}

export interface TrainsType {
  id: number;
  lat: number;
  lng: number;
  work_status: number;
  data_status: number;
  x: number;
  y: number;
  staff_no: number;
  staff_name: string;
  train_no: number;
  spot_no: number;
  created_at: string;
  updated_at: string;
  station_name: string;
  force_ride_flg: boolean;
  line_id: number;
  obc_error_flg: boolean;
  obc_error_time: Date;
  data_change_flg: boolean;
  course: number;
  display_name: string;
}

export const TransitsApi = async (): Promise<TransitsCustomType> => {
  try {
    const response = await ApiClient.get<TransitsType>('transits', {
      headers: {
        Authorization: `Bearer ${sessionStorage.getItem('access-token')}`
      }
    });
    const trains = Object.keys(response.data.datas).map((key) => ({
      spotId: key,
      trains: response.data.datas[key]
    }));
    return {
      datas: trains,
      obc_error: response.data.obc_error
    };
  } catch (err) {
    const errorMsg = ApiErrorMessage(err);
    console.error(errorMsg);
  }

  return {
    datas: [],
    obc_error: []
  };
};
